import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { categoriaSelectedSelector } from "features/Inventario/redux/selectors/categoriasSelectors"
import { selectCategoria } from "features/Inventario/redux/slices/categoriasSlice"
import { AnimatePresence, motion } from "framer-motion"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useTranslation } from "react-i18next"
import EditCategoriaForm from "./EditCategoriaForm"

const containerVariants = {
  hidden: {
    x: "100vh",
  },
  visible: {
    x: 0,
    transition: {
      type: "tween",
    },
  },
  exit: {
    x: "100vh",
    opacity: 1,
    transition: {
      type: "tween",
    },
  },
}

const EditCategoria = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const categoria = useSelector(categoriaSelectedSelector)

  const closeCategoria = (e: $TSMigrationFixMe) => {
    e.stopPropagation()
    e.preventDefault()
    dispatch(selectCategoria(null))
  }

  return (
    <AnimatePresence>
      {categoria ? (
        <motion.div
          variants={containerVariants}
          initial='hidden'
          animate='visible'
          exit='exit'
          className='categoria-form-wrap'
        >
          <div className='mt-4 d-flex justify-content-between'>
            <p className='f-18 f-weight-500'>{t("categorias.edit.title")}</p>
            <FontAwesomeIcon
              icon={["fal", "xmark"]}
              style={{ cursor: "pointer" }}
              onClick={closeCategoria}
            />
          </div>
          <EditCategoriaForm t={t} />
        </motion.div>
      ) : null}
    </AnimatePresence>
  )
}

export default EditCategoria
